module.exports = __webpack_public_path__ + "static/media/sent-mail.4c6f429d.png";